export enum E2EDepotIdsEnum {
  REWRITES_DEPOT = 2,
}

export enum E2EDepotEnum {
  EMPLOYEE_ACTIONS = 'E2E Employee Actions Depot',
  EXCHANGE = 'E2E Exchange Depot',
  RETURN_DEVICE = 'E2E Return Device Return Depot',
}
